import React from 'react'
import { Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import NavLink from '../components/NavLink';
import { Guardian } from '@xaamin/guardian';
import Tenancy from '../../shared/tenancy/Tenancy';
import Loading from '../../facturotopia/loading/Loading';

const ReceptorAppSidebar = ({ live, busy, onMenuItemClick, onCompanyClick, onTenancyChange, ...rest }) => {
  const sidebarContainerClassName = 'sidebar-container ' + (!!live ? 'live': '');

  return (
    <div className={ sidebarContainerClassName }>
      <div className="scrollbar">
        <Nav className="flex-column">

          <Nav.Link as="div" eventKey="tenancy" to="#tenancy" className="tenancy-link mt-3">
            { busy && <Loading /> }

            { !busy && (
                <Tenancy live={ live } touchable={ false } onTenancyChange={ onTenancyChange } />
              )
            }
          </Nav.Link>

          <Nav.Link as={ NavLink } eventKey="dashboard" to="/ext/receptores/facturas" onClick={ onMenuItemClick }>
            <FontAwesomeIcon icon={ ['far', 'file'] } />
            <span className="nav-link-text">Facturas</span>
          </Nav.Link>

          { Guardian.allows('autofacturacion.access') && (
            <Nav.Link as={ NavLink } eventKey="dashboard" to="/ext/receptores/autofacturacion/tickets" onClick={ onMenuItemClick }>
              <FontAwesomeIcon icon={ ['fas', 'file-alt'] } />
              <span className="nav-link-text">Autofacturación</span>
            </Nav.Link>
          )}

        </Nav>
      </div>
    </div>
  )
}

export default ReceptorAppSidebar
